<template>
  <div class="picture-wrapper" ref="picShow">
    <div class="picture-show">
      <swiper :options="swiperOption">
        <swiper-slide class="swiper-no-swiping">
          <div class="swiper-zoom-container">
            <img :data-src="content.url | picture" class="swiper-lazy">
            <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="btn-more" @click="showMore">
      <span>查看更多</span>
      <img src="@/assets/img/arrow-more.png">
    </div>
    <div class="picture-info">
      <ul class="content-list" v-if="headers">
        <li
          v-for="(item, index) in headers"
          v-if="content[item.tag]"
          :key="index"
        >
          <h4>{{item.name}}:</h4>
          <span>{{content[item.tag]}}</span>
        </li>
        <!-- <li class="picture-download">
          <h4>原图下载:</h4>
          <span><a :href="content.url | picture" :download="content.url | picture">{{content.url | picname}}</a></span>
        </li> -->
      </ul>
    </div>
    <div class="btn-backtop" @click="backTop">
      <img src="@/assets/img/arrow-backtop.png">
      <span>回到顶部</span>
    </div>
    <div class="btn-close" @click="$emit('close')">
      <img src="@/assets/img/close-x.png">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: Object,
    headers: Array
  },
  data() {
    return {
      swiperOption: {
        zoom: true,
        maxRatio: 7,
        lazy: true,
        noSwiping: true
      }
    };
  },
  filters: {
    picture(value) {
      return value.replace("210.33.124.164:8080/pms", "shadow.caa.edu.cn/py");
    },
    picname(value) {
      const s = value.lastIndexOf("/") + 1;
      return value.slice(s);
    }
  },
  methods: {
    showMore() {
      this.$refs.picShow.scrollTop = 500;
    },
    backTop() {
      this.$refs.picShow.scrollTop = 0;
    }
  }
};
</script>

<style lang="scss">
@import "../assets/base";
.picture-wrapper {
  @include pageset;
  left: 0;
  padding-bottom: 1rem;
  color: $text-picinfo;
  background-color: rgba(0, 0, 0, 0.75);
  overflow-y: auto;

  .btn-more,
  .btn-backtop {
    position: relative;
    display: inline-block;
    text-align: center;
    @include center-x;

    span {
      font-size: 0.875rem;
      display: block;
    }

    @include img-fluid;
    img {
      margin-top: 0.5rem;
      width: 2rem;
    }
  }

  .btn-close {
    position: absolute;
    z-index: 200;
    top: 4rem;
    right: 1rem;
    width: 2rem;
    height: 2rem;

    @include img-fluid;
  }
}

.picture-show {
  height: 80vh;
  padding: 2rem 1rem 1rem;
  text-align: center;
  @include img-fluid;

  .swiper-container {
    height: 100%;
  }
}

.picture-info {
  padding: 1rem 2rem;
  font-size: 0.875rem;

  h4 {
    display: inline-block;
    margin-right: 0.5rem;
    margin-top: 0;
    margin-bottom: 0.5rem;
  }

  .picture-download {
    a {
      color: $text-picinfo;
      text-decoration: none;
    }
  }
}
</style>
